import { render, staticRenderFns } from "./FirstlevelClassification.vue?vue&type=template&id=3c4fc60b&scoped=true"
import script from "./FirstlevelClassification.vue?vue&type=script&lang=js"
export * from "./FirstlevelClassification.vue?vue&type=script&lang=js"
import style0 from "./FirstlevelClassification.vue?vue&type=style&index=0&id=3c4fc60b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4fc60b",
  null
  
)

export default component.exports